<div class="container" id="print-section">

<table style="width:100%;border:2px solid #000;border-collapse:collapse;text-align:center;">

  <!-- HEADER -->
  <tr>
    <td colspan="5" style="border:2px solid #000;font-weight:bold;font-size:20px;">
      विवेक पुस्तक प्रकाशन
    </td>

    <td colspan="5" style="border:2px solid #000;font-size:20px;font-weight:bold;">
      पुस्तक छपाई आदेश
    </td>
  </tr>

  <!-- TOP INFO -->
  <tr>
    <td colspan="5" style="border:2px solid #000;">
      दिनांक : {{ today | date:'dd-MM-yyyy' }}
    </td>

    <td colspan="5" style="border:2px solid #000;">
      पुस्तकाचे नाव:{{ book_name }}
    </td>
  </tr>

  <!-- TOTAL HEADER -->
  <tr>
    <td colspan="7" style="border:2px solid #000;text-align:left;">
      एकूण प्रती : {{ totalprati }}
    </td>
     <!-- <td colspan="2">
     
    </td> -->

    <td colspan="1" style="border:2px solid #000;text-align:right;">
      एकूण पृष्ठ :
    </td>

    <td colspan="1" style="border:2px solid #000;">
      <input type="number"
             [(ngModel)]="totalpsankhya"
             style="width:100%;border:none;text-align:left;">
    </td>
  </tr>

  <!-- COLUMN HEADER -->
  <tr>
    <td style="border:2px solid #000;">क्रमांक</td>
    <td colspan="3" style="border:2px solid #000;text-align:left;">विगत</td>
    <td colspan="2" style="border:2px solid #000;">प्रती</td>
    <td colspan="3" style="border:2px solid #000;">शेरा</td>
  </tr>

  <!-- ROWS -->
  <tr *ngFor="let item of tempdata; let i = index">

    <td style="border:2px solid #000;">{{ item.no }}</td>

    <td colspan="3" style="border:2px solid #000;text-align:left;">
      <input *ngIf="!item.auto"
             [(ngModel)]="item.name"
             style="width:100%;border:none;text-align:left;">
      <span *ngIf="item.auto">{{ item.name }}</span>
    </td>

    <td colspan="2" style="border:2px solid #000;">
      <input *ngIf="!item.auto"
             type="number"
             [(ngModel)]="item.prati"
             (input)="totalPrati()"
             style="width:100%;border:none;text-align:center;">
      <span *ngIf="item.auto">{{ item.prati }}</span>
    </td>

    <td colspan="3" style="border:2px solid #000;">
      <input *ngIf="!item.auto"
             [(ngModel)]="item.shera"
             style="width:100%;border:none;">
    </td>

  </tr>

  <!-- TOTAL ROW -->
  <tr>
    <td colspan="4" style="border:2px solid #000;font-weight:bold;">
      एकूण
    </td>

    <td colspan="2" style="border:2px solid #000;font-weight:bold;">
      {{ totalprati }}
    </td>

    <td colspan="4" style="border:2px solid #000;">
      <button
        (click)="addNewtempdata()"
        style="background:#1976d2;color:#fff;border:none;padding:5px 10px;border-radius:4px;">
        +
      </button>
    </td>
  </tr>

</table>

</div>

<!-- ACTION BUTTONS -->
<div style="margin-left:70%;margin-bottom:2%;">

  <button mat-raised-button color="warn"
          (click)="exportexcel('Print_Order')">
    Export
  </button>

  <button mat-raised-button color="primary"
          printSectionId="print-section"
          ngxPrint>
    Print
  </button>

  <button mat-raised-button color="primary"
          (click)="save()">
    Save
  </button>

  <button class="btn" (click)="closeDialog()">
    Close
  </button>

</div>